module.exports = __webpack_public_path__ + "static/media/sound2.5cc98d8f.mp3";